export const COUNTRIES = [
    'Slovenia',
    'Czech_Republic',
    'Croatia',
    'Italy',
    'Slovakia',
    'Poland',
];